import { PublicService } from "./axiosInstance";
import endpoints from "./endpoints";

const learnApi = {
  async getLearnArticles(params = {}) {
    const res = await PublicService.get(endpoints.LEARN_ARTICLES, { params });
    return res.data;
  },
  async getLearnArticle(slug) {
    const res = await PublicService.get(endpoints.LEARN_ARTICLE_DETAIL(slug));
    return res.data;
  },
};

export default learnApi;
